import Lookup from 'src/componentes/select2';

const TemplatePerdaOperacionalLookup = ({ ...rest }) => <Lookup labelKey="nome" valueKey="id" url="/TemplatePerdaOperacionalLookup" clearable={false} {...rest} />;

export default TemplatePerdaOperacionalLookup;